export const processSteps = [
  {
    number: '01',
    title: 'Define the Brief',
    description:
      'Clarify the role, hiring priorities, required experience, and the qualities that matter to your team.',
  },
  {
    number: '02',
    title: 'Search & Identify',
    description:
      'Research the relevant talent market and identify professionals whose experience aligns with the brief.',
  },
  {
    number: '03',
    title: 'Engage Candidates',
    description:
      'Approach potential candidates with personalized, confidential outreach and assess initial interest and alignment.',
  },
  {
    number: '04',
    title: 'Introduce & Support',
    description:
      'Present relevant candidates and support the next steps within your own selection process.',
  },
];
